// @flow @jsx h
import { Component, h } from 'preact'
import { VideoContent } from './VideoContent'

/* styles */
import styles from './index.css'

type Props = {
  playing: boolean,
  poster: string,
  mp4: string,
  webm: string
}

export class VideoElement extends Component<Props> {
  render () {
    const { playing, poster, mp4, webm } = this.props
    const sources = [{ type: 'video/mp4', src: mp4 }, { type: 'video/webm', src: webm }]

    return <div class={styles.videoElement}>
      <div class={styles.videoElement__video}>
        <VideoContent
          playing={playing}
          sources={sources}
          poster={poster}
          textTracks={[]} />
      </div>
    </div>
  }
}
